var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"e-layout__action"},[_c('e-tooltip',{attrs:{"content":"Save snippet to enable sharing","disabled":_vm.isShareEnabled}},[_c('button',{staticClass:"e-btn",attrs:{"disabled":!_vm.isShareEnabled},on:{"click":_vm.share}},[_c('e-icon',{attrs:{"icon":"link"}}),_vm._v(" Share ")],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }